import angular from 'angular';

export default angular.module('Sq.Administration.Agents', []);
